module.exports = __webpack_public_path__ + "assets/img/logo-dark.fdc2c039.svg";